document.addEventListener('DOMContentLoaded', function() {
	// Initialiser Swiper pour tous les carousels de formations
	const formationsCarousels = document.querySelectorAll('.formations-swiper');
	
	if (typeof Swiper !== 'undefined' && formationsCarousels.length > 0) {
		formationsCarousels.forEach(function(carousel) {
			new Swiper(carousel, {
				slidesPerView: 1.25,
				spaceBetween: 20,
				breakpoints: {
					640: {
						slidesPerView: 2.2,
						spaceBetween: 25,
					},
					1024: {
						slidesPerView: 4,
						spaceBetween: 30,
						allowTouchMove: false, // Désactive le swipe sur desktop
					}
				}
			});
		});
	} else if (formationsCarousels.length > 0) {
		console.warn('Swiper is not loaded. Please ensure Swiper.js is included in your theme.');
	}
});